import Backbone from "backbone";
import SharedDispatcher from "../others/SharedDispatcher";
import FlashMessageTemplate from "../../../templates/FlashMessage.mustache";
import $ from "jquery";

  export default class extends Backbone.View{
    constructor(options = {}){
      options.el = options.el || $(FlashMessageTemplate.render()).get(0);
      super(options);
    }
    initialize() {
      this.show = this.show.bind(this);
      this.hide = this.hide.bind(this);
      this.toggle = this.toggle.bind(this);

      this.isVisible = false;

      this.listenTo(SharedDispatcher, "flashmessage:show", this.show);
      this.listenTo(SharedDispatcher, "flashmessage:hide", this.hide);
      this.listenTo(SharedDispatcher, "flashmessage:toggle", this.toggle);
    }

    get events(){
      return {
        "click": "triggerClick",
        "click .js-FlashMessage-close": "hide"
      }
    }

    triggerClick() {
      SharedDispatcher.trigger("flashmessage:click");
    }

    show() {
      if (!this.isVisible) {
        this.isVisible = true;
        this.render();
        window.setTimeout(this.hide, 2000);
      }
    }

    hide() {
      if (this.isVisible) {
        this.isVisible = false;
        this.render();
      }
    }

    toggle() {
      if (this.isVisible) {
        this.isVisible = false;
      } else {
        this.isVisible = true;
      }
      this.render();
    }

    render() {
      SharedDispatcher.trigger("overlay:hide");
      if (this.isVisible) {
        this.$el.addClass("FlashMessage--visible");
      } else {
        this.$el.removeClass("FlashMessage--visible");
      }
    }
  }
